<!--
 * @Author: your name
 * @Date: 2021-03-11 16:03:07
 * @LastEditTime: 2021-03-29 17:41:07
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \mooklook_phone\src\views\AOG.vue
-->

<template>
  <div class="article_detail">
    <div class="content" :style="{minHeight:height+'px'}">
      <div v-html="articleData.content || ''"></div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import Footer from "@/components/Footer";
export default {
  components: { Footer },
  // 定义属性
  data() {
    return {
      height: 0,
      articleData: "",
      isPhone: document.body.clientWidth < 920,
    };
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {},
  // 方法集合
  methods: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (this.$route.query.id) {
      this.articleData = this.$route.query;
     if(this.articleData.content && this.articleData.content.indexOf('"') != -1)this.articleData.content =JSON.parse(this.articleData.content)? JSON.parse(this.articleData.content):this.articleData.content
    }
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let height = this.isPhone?233:427
    this.height = window.screen.availHeight - height;
  },
};
</script>

<style lang='less' scoped>
.article_detail {
  .content {
    .title {
      text-align: center;
    }
  }
}
</style>
